<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-23T10:39:11+01:00
@Email:  tom@lorinthe.com
@Project: Qrespi corporate website
@Last modified by:   tom
@Last modified time: 2019-06-09T12:47:31+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved
-->

<template lang="html">

  <div id="video-embed" >
    <!-- show spinner as long as video component not ready attribute "spin" keeps using cpu?-->
    <icon id="video-spinner" name="spinner" scale="3"/>
    <!-- <h6 id="video-overlay-header" class="pl-3" v-html="$t('intro.embedvideo.title')"/> -->
    <b-embed
      type="video"
      aspect="16by9"
      controls
      poster="@/assets/video/PuckbyQrespi-poster-m.jpg"
      preload="none"
      @canplay="setVideoTarget"
      @playing="videoPlaying" >
      <source src="@/assets/video/Puck-by-Qrespi-Introduction-v22.webm"
              type="video/webm;codecs=&quot;vp8, vorbis&quot;" >
      <source src="@/assets/video/Puck-by-Qrespi-Introduction-v22.mp4"
              type="video/mp4;codecs=&quot;avc1.42E01E, mp4a.40.2&quot;" >
      <track label="English"
             kind="subtitles"
             srclang="en"
             src="@/assets/video/Puck-by-Qrespi-Introduction-v22.en.vtt">
      <track label="Deutsch"
             kind="subtitles"
             srclang="de"
             src="@/assets/video/Puck-by-Qrespi-Introduction-v22.de.vtt">
      <track :default="activeLocale=='nl'"
             label="Nederlands"
             kind="subtitles"
             srclang="nl"
             src="@/assets/video/Puck-by-Qrespi-Introduction-v22.nl.vtt">
    </b-embed>
    <!-- <a href="#" class="text-white" @click="play()">play</a>
    <a href="#" class="text-white" @click="pause()">pause</a> -->
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  data: function () {
    return {
      activeLocale: Vue.config.lang,
      videoElement: null,
      googleNotified: false
    }
  },
  // computed: {
  //   // if needed to determine if video is playing or not
  //   playing () { return !this.paused }
  // },
  methods: {
    setVideoTarget (event) {
      // store the videoElement target
      this.videoElement = event.target
    },
    videoPlaying () {
      console.log('Video is playing...')
      if (!this.googleNotified) {
        this.googleNotified = true
        this.$ga.event({
          eventCategory: 'qrespi',
          eventAction: 'main-video',
          eventLabel: 'playing',
          eventValue: 0
        })
      }
    }
    // // additional external buttons if needed
    // play () {
    //   this.videoElement.play()
    // },
    // pause () {
    //   // also used for stop' stop is not media event https://www.w3.org/2010/05/video/mediaevents.html
    //   this.videoElement.pause()
    // }
  }
}
</script>

<style lang="scss">

  #video-embed {
    border: 1px solid $secondaryDark;
    #video-spinner {
      color: $primaryWhite;
      position: absolute;
      margin-top: 30%;
      margin-left: 45%;
    }

    #video-overlay-header {
      width: 100%;
      // z-index: 1;
      padding:  5px;
      margin: 0 !important;
      color: $primaryWhite;
      /* offset-x | offset-y | blur-radius | color */
      text-shadow:  0.1em 0.1em 0.2em black;
      background-color: $secondaryDark;
    }
  }

</style>
